import { useEffect, useRef, useState } from 'react';

// args value array can be anything
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Func = (...args: any[]) => void;

export const useDebounce = (callback: Func, delay: number) => {
  const latestCallback = useRef<Func>();
  const latestTimeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    latestCallback.current = callback;
  }, [callback]);

  return () => {
    if (latestTimeout.current) {
      clearTimeout(latestTimeout.current);
    }

    latestTimeout.current = setTimeout(() => {
      latestCallback.current?.();
    }, delay);
  };
};

// debounce value can be anything
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebounceValue = (value: any, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
